'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = require('decisiv-ui-utils');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StyledContent = (0, _decisivUiUtils.buildStyledComponent)('Tabs.Content', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row));

function Content(_ref, context) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  var activeTab = context[_constants.TOGGLE_TAB_CONTEXT].activeTab;

  var activeContent = _react2.default.Children.map(children, function (child, i) {
    return activeTab === i ? child : null;
  });

  return _react2.default.createElement(
    StyledContent,
    props,
    activeContent
  );
}

Content.contextTypes = _defineProperty({}, _constants.TOGGLE_TAB_CONTEXT, _propTypes2.default.object.isRequired);

Content.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Tabs/Content.js
// module id = 1690
// module chunks = 2